// extracted by mini-css-extract-plugin
export default {"box":"masterVrpPage_box__ZMfj6"};